// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1KU_D","label":"Labeled_label__3bKG6","divider":"Labeled_divider__3IYk4"};